import { getAdIds } from '@/src/utils/adIdUitls';
import { ShopChannel, ERROR_CODE, CALCULATE_PRICE_REQUEST_SCENE } from './constant';
import { CalculateOut, CalculatePrice, ShopCategoryItem } from '../component';
import i18nClient from '../locales/i18n.config';

const SLCommon = Mach.requireModule('SLCommon');
const Network = Mach.requireModule('Network');
const Location = Mach.requireModule('SLLocation');
const Toast = Mach.requireModule('Toast');

export const SHOPURL = {
  CALCULATEPRICE: 'v1/shoppingcart/calculatePrice', // 计算购物车价格
  USERCARTINFO: 'v1/shoppingcart/userCartInfo', // 全局购物车数据
  UPLOADSHOPPINGCARTINFO: 'v1/shoppingcart/uploadShoppingCartInfo', // 同步购物车数据
  SHOPINFO: 'v1/shop/shopInfo', // 获取门店信息
  PRODUCTLIST: 'v1/shop/productList', // 获取商品列表
  /** 商品列表分页 */
  PRODUCTRENDER: 'v1/shop/product/render',
  MULTISKU: 'v1/shop/productSpecifics', //多规格浮层接口
  MULTISKUVALIDATION: 'v1/shop/preCheck', //多规格浮层校验接口
  MULTISKUCALCULATE: 'v1/shop/productPrice', //多规格浮层算价接口
  NEWUSERCOUPONSEND: 'dsp/newuser/coupon/send', // 新客领券（新人大礼包）
  ORDERPRODUCT: 'v1/order/product', // 查询订单菜品
  PICKUPSCANSHOP: 'accurate/v1/event/report/pickupscan', // 自提扫门店码
  /** 凑单商品列表接口 */
  ADDITEMPRODUCTLIST: 'v1/shop/addItemProductList',
};

/**
 *  获取位置信息
 */
const getLocation = () => {
  const locationObj = Location?.getLocation();
  return {
    latitude: locationObj?.latitude,
    longitude: locationObj?.longitude,
    actualLatitude: locationObj?.actualLatitude,
    actualLongitude: locationObj?.actualLongitude
  };
};

/**
 * 获取再来一单商品数据
 * @param orderViewId 订单id
 * @returns
 */
export const orderProductRequest = (orderViewId: string) => {
  const params = {
    url: SHOPURL.ORDERPRODUCT,
    method: 'POST',
    dataType: 'json',
    data: {
      orderViewId,
    }
  };
  return new Promise((resolve, reject) => {
    Network.request(params, (res) => {
      resolve(res.data);
    });
  });
};

/**
 * 发券（新人大礼包）
 * @param couponBizCode 发券渠道 1：门店页的新人横条； 2：主站门店提单 3：一口价专区提单
 */
export const couponSendRequest = (couponBizCode: number) => {
  // 定位信息
  const locationObj = Location?.getLocation();
  const location = {
    latitude: locationObj?.latitude,
    longitude: locationObj?.longitude,
    actualLatitude: locationObj?.actualLatitude,
    actualLongitude: locationObj?.actualLongitude
  };

  const param = {
    bizCode: couponBizCode,
    ...location,
  };

  const params = {
    url: SHOPURL.NEWUSERCOUPONSEND,
    method: 'POST',
    dataType: 'json',
    data: param,
  };
  Network.requestWx(params, (result: any) => {
    if (result?.data?.code !== 0) {
      // 请求失败，异常上报
      Mach.requireModule('Raptor').reportBusinessException(params.url, JSON.stringify({ bizCode: couponBizCode, result }), { type: 'normal' });
    }
  });
};

/**
 * 门店信息
 * @param shopId 门店id
 * @returns
 */
export const shopInfoRequest = (shopId: string, userGetMode: string) => {
  const locationObj = Location?.getLocation();

  const param = {
    shopId,
    sourcePageType: '0',
    latitude: locationObj?.latitude,
    longitude: locationObj?.longitude,
    actualLatitude: locationObj?.actualLatitude,
    actualLongitude: locationObj?.actualLongitude,
    channelId: 'banner-10002',
    userGetMode,
    bundleVersion: Mach.env.bundleVersion
  };

  const params = {
    url: SHOPURL.SHOPINFO,
    method: 'POST',
    headers: {
      ...CommonHeaders.getCommonHeader()
    },
    data: param,
  };
  return new Promise((resolve, reject) => {
    Network.requestWx(params, (result: any) => {
      if (result?.data && result?.data?.code === 0) {
        resolve(result);
      } else {
        // 请求失败，触发兜底
        reject(result);
      }
    });
  });
};

/**
 * 门店商品列表数据
 * @param shopId
 * @returns
 */
export const productListRequest = (requestParams: { shopId: string; userGetMode: string; selectedProduct?: any; }) => {
  const { shopId, userGetMode, selectedProduct } = requestParams;
  const getLatLng = () => {
    const SLLocation = Mach.requireModule('SLLocation');
    const location = SLLocation?.getLocation() || {};
    return {
      latitude: location?.latitude,
      longitude: location?.longitude,
      actualLatitude: location?.actualLatitude,
      actualLongitude: location?.actualLongitude,
    };
  };

  const param = {
    shopId,
    sourcePageType: '0',
    locationSpuId: '',
    locationCategoryId: '',
    searchWord: '',
    location: getLatLng(),
    userGetMode,
    bundleVersion: Mach.env.bundleVersion,
    selectedProduct
  };

  const params = {
    url: SHOPURL.PRODUCTLIST,
    method: 'POST',
    dataType: 'json',
    headers: {
      ...CommonHeaders.getCommonHeader()
    },
    data: param,
  };
  return new Promise((resolve, reject) => {
    Network.request(params, (result: any) => {
      if (result?.data && result?.data.code === 0) {
        resolve(result);
      } else {
        // 请求失败，触发兜底
        reject(result);
      }
    });
  });
};

/**
 * 商品列表分页
 * @param shopId 门店id
 * @param userGetMode 外卖、自提模式
 * @param shopCategoryList 要获取的spu
 * @returns
 */
export const productRenderRequest = (shopId: string, userGetMode: string, shopCategoryList: ShopCategoryItem[]) => {
  const location = getLocation();
  const params = {
    url: SHOPURL.PRODUCTRENDER,
    method: 'POST',
    dataType: 'json',
    headers: {
      ...CommonHeaders.getCommonHeader()
    },
    data: {
      shopId,
      userGetMode,
      shopCategoryList,
      location
    }
  };
  return new Promise((resolve, reject) => {
    Network.request(params, (result: any) => {
      if (result?.data?.code === 0) {
        resolve(result);
      } else {
        reject(result);
      }
    });
  });
};

/**
 * 购物车接口（参数后续改为对象类型，方便扩展）
 * @param shopInfo
 * @param skuList
 * @param firstCome
 * @param userGetMode
 * @param changeUserGetMode 切换用户履约模式 0:不切换 1:切换,请求购物车场景，切换tab、加购、进入门店
 * @returns
 */
export const calculatePriceRequest = (shopInfo, skuList, firstCome, userGetMode, scene: CALCULATE_PRICE_REQUEST_SCENE = CALCULATE_PRICE_REQUEST_SCENE.addCart) => {
  const locationObj = Location?.getLocation();
  // 定位信息
  const location = {
    latitude: locationObj.latitude,
    longitude: locationObj.longitude,
    actualLatitude: locationObj?.actualLatitude,
    actualLongitude: locationObj?.actualLongitude
  };
  const data = {
    location,
    shopId: shopInfo?.shopId,
    firstCome,
    minCostPrice: shopInfo?.minCostPrice,
    deliverFee: shopInfo?.deliveryInfo?.deliveryFee, // 自提模式不用传递配送费
    skuList,
    userGetMode,
    changeUserGetMode: scene === CALCULATE_PRICE_REQUEST_SCENE.switchTab ? 1 : 0
  };
  // 接口异常要上报param
  const params = {
    url: SHOPURL.CALCULATEPRICE,
    method: 'POST',
    dataType: 'json',
    headers: {
      ...CommonHeaders.getCommonHeader()
    },
    data
  };
  return new Promise<CalculatePrice>((resolve, reject) => {
    Network.request(params, (result) => {
      if (result?.data && result?.data.code === 0) {
        const res = result.data;
        resolve(res);
      } else if (result?.data && result?.data.code === ERROR_CODE.CART_MAX_COUNT) {
        reject(result);
        const message = result?.data?.message || '';
        Toast.show(message, 2, {
          type: 'B', // 异常类型
          code: result?.data?.code || '0',
          extraInfo: {
            ...params,
            msg: message,
            method: 'calculatePrice',
          }
        });
      } else {
        // 请求失败，触发兜底
        if (!CommonHeaders.isSpecialChannel()) {
          //线上包逻辑：接口异常则弹出来Toast
          reject(result);
          const message = i18nClient.getText('shop_cartlayer_fail');
          Toast.show(message, 2, {
            type: 'B', // 异常类型
            code: result?.data?.code || '0',
            extraInfo: {
              ...params,
              msg: result?.data?.message || '',
              method: 'calculatePrice',
            }
          });
        } else {
          //非正式包(BD包等等)逻辑，勿动
          //1. 自取/外卖切换场景时，默认返回成功，上层执行后续逻辑，
          //2. 加购场景时，抛异常
          if (scene === CALCULATE_PRICE_REQUEST_SCENE.switchTab) {
            // @ts-ignore
            const data: CalculateOut = {
              productUnavailableAlertTip: '',
              skuList: []
            };
            // @ts-ignore
            resolve({ data });
          } else {
            reject(result);
          }
        }
      }
    });
  });
};

let currentChannel = '';
export const CommonHeaders = {
  updateChannel(channel) {
    currentChannel = channel;
  },

  isSpecialChannel() {
    const { channel } = SLCommon?.getEnv?.() || {};
    return channel === ShopChannel.BD //场景：全供给包
        || currentChannel === ShopChannel.BD
        || currentChannel === ShopChannel.OPEN
        || currentChannel === ShopChannel.MERCHANT //场景：复用到B端
        || currentChannel === ShopChannel.PARTNER; //场景：复用到B Partner端
  },

  getCommonHeader() {
    if (currentChannel) {
      return {
        channel: currentChannel
      };
    } else {
      return {};
    }
  }
};

/**
 * 自提门店扫码发券
 * @param
 */
export const pickupScanCoupon = async (shopId, pickupDownloadChannel) => {
  // 定位信息
  const locationObj = Location?.getLocation();
  const location = {
    latitude: locationObj?.latitude,
    longitude: locationObj?.longitude,
    actualLatitude: locationObj?.actualLatitude,
    actualLongitude: locationObj?.actualLongitude
  };
  const { adid, gaid, idfa } = await getAdIds();
  const param = {
    shopId,
    pickupDownloadChannel,
    adid,
    gaid,
    idfa,
    ...location,
  };

  const params = {
    url: SHOPURL.PICKUPSCANSHOP,
    method: 'POST',
    dataType: 'json',
    data: param,
  };
  Network.requestWx(params, () => {});
};

export const addItemProductList = (shopId: string, userGetMode: string, diffPrice: number = 0) => {
  // 凑单差价
  const param = {
    userGetMode,
    shopId,
    diffPrice
  };
  const params = {
    url: SHOPURL.ADDITEMPRODUCTLIST,
    method: 'POST',
    dataType: 'json',
    data: param,
  };

  return new Promise((resolve, reject) => {
    Network.requestWx(params, (result: any) => {
      if (result?.data?.code === 0) {
        const res = result.data;
        resolve(res);
      } else {
        // 请求异常，弹toast
        Toast.show(i18nClient.getText('shouye_default_4'), 2, {
          type: 'B', // 异常类型
          code: result?.data?.code || '0',
          extraInfo: {
            ...params,
            msg: result?.data?.message || '',
            method: 'calculatePrice',
          }
        });
      }
    });
  });
};
